
"use strict"

import './components/navigation'
import './components/global-operations'
import './components/header'
import './components/content-carousel'
import './components/wysiwyg-carousel'
import './components/logo-carousel'
import './components/image-text-carousel'
import './components/testimonials'
import './components/filters'
import './components/lang-switcher'
import './components/calculator'
import './components/gltr-calculator'
import './components/tabbed-content'
import './components/latest-vacancies'
import './components/onetrust'

import videoLightbox from './components/video-lightbox'
import expand from './components/expand'
import searchWidget from './components/search-widget'
import { http } from './utility/http.js'

searchWidget()
videoLightbox()

expand('.accordion__button', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)
})